<template>
  <div class="button">
    <router-link :to="{ path: '/' +text }">{{ text }}</router-link>
  </div>
</template>

<script>
export default {
  name: "appButton",
  props: {
    text: {
      type: String,
      default: "Button"
    }
  }
};
</script>

<style lang="scss">
.button {
  text-transform: uppercase;
  border: 1px solid #efefef;
  border-radius: 4px;
  color: #b5b5b5;
  padding: 8px;
  font-size: 0.8rem;
  background: #ffffff;
  box-shadow: 0 0 50px 5px rgba(201, 201, 201, 0.1);
  cursor: pointer;

  &:hover {
    box-shadow: 0 0 50px 5px rgba(201, 201, 201, 0.25);
  }

  a {
    text-decoration: none;
    color: #000000;

    &:visited {
      color: #000000;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Button.vue